module.exports = __webpack_public_path__ + "img/badge_viaggi_b.492624ce.jpg";